import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function AnimatedSection({
  children,
  className = '',
  delay = 0
}: AnimatedSectionProps) {
  return <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-80px'
  }} className={className} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-11">
      {children}
    </motion.div>;
}
export function AnimatedItem({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <motion.div variants={itemVariants} className={className} data-id="element-12">
      {children}
    </motion.div>;
}